import { createRouteRef } from '@backstage/core-plugin-api';

export const entityContentRouteRef = createRouteRef({ id: 'packages' });

export const packageDependenciesRouteRef = createRouteRef({
  id: 'packagedependencies ',
});
